import { render } from "./ShowLegend.vue?vue&type=template&id=3028d496"
import script from "./ShowLegend.vue?vue&type=script&lang=js"
export * from "./ShowLegend.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__